import React, { FC } from 'react';
import RichText from '../richtext';
import Styles from './StaticProductEntitle.module.scss';
import ToolTip from '../ToolTip/ToolTip';
import { StaticBenefitsSchema } from './StaticProductDatatypes';

//US_31295
const StaticBenefit: FC<StaticBenefitsSchema> = ({ content,benefitData,constants, pricesToggleState, togglePriceLabel }) => {
  const int_fmc = benefitData?.int_fmc;
  const mob_fmc = benefitData?.mob_fmc;
  const benefit_category = benefitData?.mob_benefit_category;
  const benefitDataa = (option: any) => {
    return (
      <span className={Styles.optionwrapper}>
        {option?.icon?.filename && <img src={option?.icon?.filename} width={24} height={24} alt='benefit icon' />}
        <span className={`${Styles.text} ms-2`}>
          {/* US_31295 */}
          <RichText content={(option?.id === 'multimob_fmc' || option?.id === 'int_fmc') && pricesToggleState ? togglePriceLabel : option?.text} />
        </span>
      </span>
    );
  };

  return (
    <div>
      <div className={Styles.optioncontainer}>
        <div className={Styles.optionlist}>
          {content?.length > 0 && <span className={Styles.optiontitle}>{constants?.benefits}</span>}
          {(content || []).map((option: any, i: number) => {
            return option?.id == 'default' ||
              (option?.id == 'int_fmc' && int_fmc > 0 && benefit_category != 'FMC') ||
              (option?.id == 'multimob_fmc' && mob_fmc > 0 && benefit_category == 'MULTIMOBILE') ||
              (option?.id == 'combi_fmc' && mob_fmc > 0 && benefit_category == 'FMC') ||
              (option?.id == 'mob_fmc' && mob_fmc > 0 && benefit_category == 'FMC') ? (
              <div key={i} className='d-flex justify-content-between align-items-center'>
                <span>
                  {option && (
                    <span className='d-flex'>
                      {option?.text && (
                        <>{benefitDataa(option)}</>
                      )}
                    </span>
                  )}
                </span>
                <span>
                  {option?.toolTip && <ToolTip content={option?.toolTip} isBenefit={true} />}
                </span>
              </div>
            ) : (
              ''
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StaticBenefit;
